/* eslint-disable no-irregular-whitespace */
import styled from "styled-components";
import { DoneIcon } from "../icon/DoneIcon";

interface IProps {
    handleClose: () => void;
}

export const PumpkinPopupDone = ({ handleClose }: IProps) => {
    return (
        <StyledShowDone>
            <div className="layout-ex-img">
                <div style={{ marginBottom: "10px" }}>
                    <DoneIcon />
                </div>
                <div className="title">ส่งขอใบรับประกัน ออนไลน์สำเร็จ</div>
                <div className="detail">คุณจะได้รับคะแนนเมื่อระบบตรวจสอบเสร็จสิ้นภายใน 24 ชม.</div>
            </div>
            <div className="close-popupinvite" onClick={handleClose}>
                <img src="../images/ic-close-invite.svg" alt="close icon" />
            </div>
        </StyledShowDone>
    );
};

const StyledShowDone = styled.div`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    padding: 16px;

    .layout-ex-img {
        width: 215px;
        padding: 20px;
        background-color: #fff;
        border-radius: 20px;
        text-align: center;
        position: relative;

        .title {
            color: #1cc556;
            font-weight: 600;
            margin-bottom: 5px;
            font-size: 20px;
            font-style: normal;
            line-height: normal;
        }

        .detail {
            font-size: 14px;
            color: #9b9b9b;
            margin-bottom: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
        }
    }

    .close-popupinvite {
        position: relative;
        margin-top: 30px;
        z-index: 5;

        img {
            width: 32px;
        }
    }
`;
